import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export const HeatmapWidgetIcon = forwardRef<SVGSVGElement, IconProps>(function HeatmapWidgetIcon(
  { height = 32, width = 32, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 32 32"
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <path d="M2.97675 5H11.2248V8.9403H2.97675V5Z" fill="#5137A1" />
      <path d="M11.876 5H20.124V8.9403H11.876V5Z" fill="#5137A1" />
      <path d="M20.7752 5H29.0233V8.9403H20.7752V5Z" fill="#EF145D" />
      <path d="M2.97675 9.59701H11.2248V13.5373H2.97675V9.59701Z" fill="#6C4FC2" />
      <path d="M11.876 9.59701H20.124V13.5373H11.876V9.59701Z" fill="#5137A1" />
      <path d="M20.7752 9.59701H29.0233V13.5373H20.7752V9.59701Z" fill="#EF145D" />
      <path d="M2.97675 14.194H11.2248V18.1343H2.97675V14.194Z" fill="#5137A1" />
      <path d="M11.876 14.194H20.124V18.1343H11.876V14.194Z" fill="#5137A1" />
      <path d="M20.7752 14.194H29.0233V18.1343H20.7752V14.194Z" fill="#5137A1" />
      <path d="M2.97675 18.791H11.2248V22.7313H2.97675V18.791Z" fill="#6C4FC2" />
      <path d="M11.876 18.791H20.124V22.7313H11.876V18.791Z" fill="#5137A1" />
      <path d="M20.7752 18.791H29.0233V22.7313H20.7752V18.791Z" fill="#EF145D" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30 26.0149C30 26.559 29.5627 27 29.0233 27H2.97675C2.4373 27 2 26.559 2 26.0149C2 25.4709 2.4373 25.0299 2.97675 25.0299H29.0233C29.5627 25.0299 30 25.4709 30 26.0149Z"
        fill="#6C4FC2"
      />
    </SvgStyled>
  );
});
